import {Breadcrumb, Col, Divider, Row} from "antd";
import React, {useEffect, useState} from "react";
import axios from "axios";
import Markdown from 'react-markdown'

function Cookies() {

    const [content, setContent] = useState({});

    const [skeleton, setSkeleton] = useState(true);

    const apiKey = process.env.REACT_APP_STRAPI_CMS_API_KEY;

    const toggleSceleton = (value, key) => {
        if (key in value) {
            setSkeleton(false);
        } else {
            setSkeleton(true);
        }
    }

    const getMenu = async () => {
        const response = await axios.get(
            process.env.REACT_APP_STRAPI_URL + "/api/cookie/?populate=*",
            {
                headers: {
                    'Authorization': 'Bearer ' + apiKey
                }
            }
        )
        console.log(response.data.data.attributes);
        const content = response.data.data.attributes;

        setContent(content.StandartPage);
        toggleSceleton(content, 'Title');
    }

    useEffect(() => {
        getMenu().then(r => {});
    }, []);

    return (<>
        <Row gutter={24} className={"Content"}>
            <Col span={12}>
                <h1>{content.PageTitle}</h1>
            </Col>
            <Col span={12} style={{textAlign: "right"}}>
                <Breadcrumb
                    style={{float: "right"}}
                    items={[
                        {
                            href: '/',
                            title: (
                                <>
                                    <span>Home</span>
                                </>
                            ),
                        },
                        {
                            title: <>{content.PageTitle}</>,
                        },
                    ]}
                />
            </Col>
        </Row>
            <Row gutter={24} className={"Content"} style={{textAlign: "center", paddingTop: 0}}>
                <Col span={24}>
                    <h2>{content.PageSubTitle}</h2>
                    <Divider className={"TransitionColors"} orientation="left">{content.Quote}</Divider>
                </Col>
            </Row>
            <Row gutter={24} className={"Content"}>
                <Col span={24}>
                    <Markdown>
                        {content.Content}
                    </Markdown>
                </Col>
            </Row>
        </>
    )
}

export default Cookies